import React, { Component } from "react";
import { Spin } from "antd";
import {
  history,
  showErrorNotification,
  strings,
  showSuccessNotification
} from "../../helpers";
import UsersListView from "./UsersListView";

import { getUsersList, updateUserFlags } from "../../services";

export default class UsersListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersList: [],
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      searchText: "",
      filterBy: null,
      featureFlags: [
        { id: "growth_enabled", name: "Growth" },
        { id: "packages_enabled", name: "Care Packages" }
      ],
      activateModule: undefined,
      selectedUserId: null,
      selectedUserModule: null,
      selectedClinicModule: null
    };
  }

  componentDidMount() {
    this.fetchUsersList();
  }

  /**
   * @function fetchUsersList
   * @description This function get doctors data
   */
  fetchUsersList = () => {
    const { pageNo, searchText, filterBy } = this.state;
    this.setState({
      isProcessing: true
    });
    getUsersList(pageNo, searchText, filterBy)
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const { users } = response.data.data;
          const { total_records } = response.data.data;
          const { total_pages } = response.data.data;
          this.setState({
            usersList: users,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            usersList: [],
            isProcessing: false,
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ usersList: [], isProcessing: false });
      });
  };

  /**
   * @function onPageChange
   * @oaram page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, usersList: [] }, () => {
      this.fetchUsersList();
    });
  };

  /**
   * @function handleSearchText
   * @description This function get called when clicked on search icon
   */
  handleSearchText = e => {
    this.setState({ searchText: e.target.value });
  };
  /**
   * @function handleSearch
   * @description This function get called when clicked on pres button
   */
  handleSearch = () => {
    this.setState({ pageNo: 1, usersList: [] }, () => {
      this.fetchUsersList();
    });
  };

  /**
   * @function  handleFilterBy
   * @param value
   * @description This function get called when clicked on press enter
   */
  handleFilterBy = value => {
    this.setState({ pageNo: 1, usersList: [], filterBy: value }, () => {
      this.fetchUsersList();
    });
  };

  /**
   * @function  navigateToUsersDetails
   * @description This function redirect the user to doctor-details
   */
  navigateToUsersDetails = userId => {
    history.push(`/users-details/${userId}`);
  };

  handleUpdateUserFlag = record => {
    const { selectedClinicModule } = this.state;
    const params = {
      [selectedClinicModule.id]: !record[selectedClinicModule.id]
    };
    this.setState({ isProcessing: true });
    updateUserFlags(params, record.id)
      .then(response => {
        if (response?.data?.success) {
          this.setState({ selectedUserId: null, selectedClinicModule: null, activateModule: false });
          this.fetchUsersList();
          // this.resetData();
          showSuccessNotification(
            `${selectedClinicModule.name} ${"activated"} successfully`
          );
        } else {
          showErrorNotification(strings.schedule.serverError);
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  handleUpdateClinicModule = (val, optionObj, selectedClinic) => {
    this.setState({
      selectedClinicModule: optionObj?.props?.specObj,
      selectedUserId: selectedClinic?.id,
      activateModule: selectedClinic[optionObj?.props?.specObj?.id]
        ? true
        : false
    });
  };

  render() {
    const {
      usersList,
      isProcessing,
      totalRecords,
      totalPages,
      pageNo,
      searchText,
      filterBy,
      featureFlags,
      activateModule,
      selectedUserId
    } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <UsersListView
          navigateToUsersDetails={this.navigateToUsersDetails}
          usersList={usersList}
          allRecords={totalRecords}
          allPages={totalPages}
          pageNo={pageNo}
          onPageChange={this.onPageChange}
          searchText={searchText}
          handleSearchText={this.handleSearchText}
          handleSearch={this.handleSearch}
          filterBy={filterBy}
          handleFilterBy={this.handleFilterBy}
          featureFlags={featureFlags}
          activateModule={activateModule}
          selectedUserId={selectedUserId}
          handleUpdateClinicModule={this.handleUpdateClinicModule}
          handleUpdateUserFlag={this.handleUpdateUserFlag}
        />
      </Spin>
    );
  }
}
